import AddIcon from '@mui/icons-material/Add';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import NoOrdersIcon from 'assets/icons/line-assigments/no-orders.svg';
import SearchRfcIcon from 'assets/icons/line-assigments/search-rfc.svg';
import DataTable from 'widgets/datagrid/DataTable';
import { OrdersTableFilters } from './OrdersTableFilters';

export const OrdersTable = ({
  mappedRows,
  hasEndpointRows,
  Columns,
  loading,
  shouldSearch,
  rfc,
  createOrder,
  page,
  size,
  statusOptions,
  statusFilter,
  setStatusFilter,
  orderIdFilter,
  setOrderIdFilter,
  dateFilter,
  setDateFilter,
}) => {
  if (loading) {
    return (
      <Box
        height={'28rem'}
        alignContent={'center'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box alignContent={'center'}>
      {hasEndpointRows && shouldSearch && (
        <Box
          display={'flex'}
          gap={1}
          alignItems={'center'}
          justifyContent={'space-between'}
          mb={2}
          sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
        >
          <Box>
            <h4>Órdenes de vinculación</h4>
          </Box>
          <Box>
            <OrdersTableFilters
              statusFilter={statusFilter}
              setStatusFilter={setStatusFilter}
              statusOptions={statusOptions}
              orderIdFilter={orderIdFilter}
              setOrderIdFilter={setOrderIdFilter}
              dateFilter={dateFilter}
              setDateFilter={setDateFilter}
            />
          </Box>
        </Box>
      )}
      {hasEndpointRows ? (
        <Grid paddingLeft={0}>
          <Box>
            <DataTable
              rows={mappedRows}
              columns={Columns}
              loading={loading}
              page={page}
              pageSize={size}
              rowCount={1}
            />
          </Box>
        </Grid>
      ) : (
        <>
          {shouldSearch && mappedRows.length === 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
              {/* Icono */}
              <Box
                component='img'
                src={NoOrdersIcon}
                alt='Sin ordenes'
                sx={{ display: 'block', mx: 'auto', mb: 2 }}
                width={48}
                height={48}
              />

              <Typography
                gutterBottom
                sx={{ fontSize: 16, color: '#9d9d9d', fontWeight: 400 }}
                textAlign={'center'}
              >
                Sin ordenes de vinculación
              </Typography>

              <Typography
                gutterBottom
                sx={{ fontSize: 14, color: '#b3b3b3', fontWeight: 400 }}
                textAlign={'center'}
              >
                No se han generado órdenes para el RFC {rfc}
              </Typography>
              <Button
                onClick={createOrder}
                variant='contained'
                startIcon={<AddIcon />}
                style={{ backgroundColor: '#6c39d2', color: '#fff', marginTop: 16 }}
              >
                Crear orden de vinculación
              </Button>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
              {/* Icono */}
              <Box
                component='img'
                src={SearchRfcIcon}
                alt='Busqueda por RFC'
                sx={{ display: 'block', mx: 'auto', mb: 2 }}
                width={48}
                height={48}
              />

              <Typography
                gutterBottom
                sx={{ fontSize: 14, color: '#b3b3b3', fontWeight: 400 }}
                textAlign={'center'}
              >
                Consulta a la persona moral <br />
                ingresando su RFC
              </Typography>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
